import React from "react";
import { Box, InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";

function MessageSearchBar({ onChange, ctnStyle, ...rest }: any) {
  return (
    <Box sx={{backgroundColor: "#B5BAB540", borderRadius: 100, width: "100%"}}>
    <TextField
      id="input-with-icon-textfield"
      type="search"
      color="secondary"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search
              style={{
                color: "gray",
                opacity: 0.5,
                width: "100%",
                fontSize: 35,
              }}
            />
          </InputAdornment>
        ),
        // style:{marginBottom: 0}
      }}
      sx={{
        "& fieldset": {border: 'none'}
      }}
      inputProps={{
       style: {height: 15}
      }}
      style={{
        marginLeft: "1em",
        width: "90%",
        border: 'none'
      }}
      onChange={onChange}
      {...rest}
    />
    </Box>
  );
}

export default MessageSearchBar;
